import { render, staticRenderFns } from "./AddPrimaryStorage.vue?vue&type=template&id=606086ed&scoped=true&"
import script from "./AddPrimaryStorage.vue?vue&type=script&lang=js&"
export * from "./AddPrimaryStorage.vue?vue&type=script&lang=js&"
import style0 from "./AddPrimaryStorage.vue?vue&type=style&index=0&id=606086ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606086ed",
  null
  
)

export default component.exports